import UserProfile from 'components/pages/UserProfile';

import { resolvify } from 'lib/promises';

import { getTopbarAd } from 'services/ads';
import { getCategoriesList } from 'services/category';
import { getLandingsList } from 'services/landing';
import { getStoresList } from 'services/store';
import {
  getUserAcquiredBadgesList,
  getUserInfo,
  getUserUnearnedBadgesList,
} from 'services/user';

import APP from 'constants/app';
import LINKS from 'constants/links';

const BADGES_LIMIT = 8;

const Index = (props) => <UserProfile {...props} />;

export const getServerSideProps = async ({ params: { userUsername } }) => {
  if (!userUsername.startsWith('@') || userUsername === '@genio') {
    return { redirect: { destination: LINKS[404], permanent: false } };
  }

  // Regex to identify when the userUsername is an email
  // (e.g. "@marcelo.santana@promobit.com.br"), which is invalid for the API.
  // when detected, redirect to 404, same as for invalid users.
  const userUsernameWithInvalidEmailRegex =
    /^@?[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  if (userUsernameWithInvalidEmailRegex.test(userUsername)) {
    return { redirect: { destination: LINKS[404], permanent: false } };
  }

  const userUsernameWithNoAtSign = userUsername.slice(1, userUsername.length);

  try {
    const [
      user,
      { badges: acquiredBadges },
      categories,
      stores,
      featuredLandings,
      highlightedLandings,
      topbarAd,
    ] = await resolvify([
      getUserInfo({ userUsername: userUsernameWithNoAtSign }),
      getUserAcquiredBadgesList({
        limit: BADGES_LIMIT,
        userUsername: userUsernameWithNoAtSign,
      }),
      {
        fn: getCategoriesList({ selectedCategories: true }),
        fallback: getCategoriesList.fallback,
      },
      {
        fn: getStoresList({ from: 'topbar' }),
        fallback: getStoresList.fallback,
      },
      {
        fn: getLandingsList({ featured: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getLandingsList({ highlighted: true }),
        fallback: getLandingsList.fallback,
      },
      {
        fn: getTopbarAd(),
        fallback: getTopbarAd.fallback,
      },
    ]);

    if (user.userId === 0) {
      return { redirect: { destination: LINKS[404], permanent: false } };
    }

    const badges = [...acquiredBadges];

    if (acquiredBadges.length < BADGES_LIMIT) {
      const acquiredBadgesToLimitDiff = BADGES_LIMIT - acquiredBadges.length;

      const { badges: unacquiredBadges } = await getUserUnearnedBadgesList({
        userUsername: userUsernameWithNoAtSign,
        limit: acquiredBadgesToLimitDiff,
      });

      badges.push(...unacquiredBadges);
    }

    return {
      props: {
        badges,
        user,
        [APP.CTX_OPTIONAL_PROPS]: {
          categories,
          featuredLandings,
          highlightedLandings,
          stores,
          topbarAd,
        },
      },
    };
  } catch (err) {
    if (err.message.includes(404)) {
      return { redirect: { destination: LINKS[404], permanent: false } };
    }

    return { redirect: { destination: LINKS[500], permanent: false } };
  }
};

export default Index;
